import { useState } from "react";
import { Loader2, Truck, X } from "lucide-react";

const CARRIERS = ["Correos", "Correos Express", "SEUR", "MRW", "GLS", "Nacex", "DHL", "UPS", "Otro"];
const cls = "mt-1 w-full h-11 rounded-[8px] bg-[#143823] border border-[#F6EEDC]/25 px-3 text-[#F6EEDC] outline-none focus:border-[#F2B441]";

export const ShipForm = ({ id, initial, onSubmit, onCancel }) => {
  const [carrier, setCarrier] = useState(initial?.carrier || "Correos");
  const [other, setOther] = useState("");
  const [number, setNumber] = useState(initial?.number || "");
  const [url, setUrl] = useState(initial?.url || "");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    const name = carrier === "Otro" ? other.trim() : carrier;
    if (name.length < 2) { setErr("Indica el transportista"); return; }
    if (number.trim().length < 3) { setErr("Indica el número de seguimiento"); return; }
    if (url.trim() && !/^https:\/\/\S+\.\S+/.test(url.trim())) { setErr("El enlace debe empezar por https://"); return; }
    setBusy(true); setErr("");
    const ok = await onSubmit({ carrier: name, number: number.trim(), url: url.trim() || null });
    setBusy(false);
    if (!ok) setErr("No se pudo guardar. Inténtalo de nuevo.");
  };
  return (
    <form onSubmit={submit} data-testid={`ship-form-${id}`} className="mt-5 rounded-[12px] border border-[#F2B441]/40 p-4 grid sm:grid-cols-2 gap-3">
      <p className="sm:col-span-2 font-semibold flex items-center gap-2"><Truck className="w-4 h-4 text-[#F2B441]" /> Datos del envío</p>
      <label><span className="text-xs text-[#C9D6C2]">Transportista *</span>
        <select data-testid={`ship-carrier-${id}`} value={carrier} onChange={(e) => setCarrier(e.target.value)} className={cls}>
          {CARRIERS.map((c) => <option key={c} value={c}>{c}</option>)}
        </select></label>
      {carrier === "Otro" ? (
        <label><span className="text-xs text-[#C9D6C2]">Nombre del transportista *</span>
          <input data-testid={`ship-carrier-other-${id}`} value={other} onChange={(e) => setOther(e.target.value)} className={cls} /></label>
      ) : <span className="hidden sm:block" />}
      <label><span className="text-xs text-[#C9D6C2]">Nº de seguimiento *</span>
        <input data-testid={`ship-number-${id}`} value={number} onChange={(e) => setNumber(e.target.value)} className={cls} /></label>
      <label><span className="text-xs text-[#C9D6C2]">Enlace de seguimiento (opcional)</span>
        <input data-testid={`ship-url-${id}`} type="url" inputMode="url" placeholder="https://…" value={url} onChange={(e) => setUrl(e.target.value)} className={cls} /></label>
      {err && <p data-testid={`ship-error-${id}`} className="sm:col-span-2 text-sm text-[#F4A58F]">{err}</p>}
      <div className="sm:col-span-2 flex flex-wrap gap-2">
        <button type="submit" disabled={busy} data-testid={`ship-submit-${id}`} className="h-11 px-5 rounded-full bg-[#F2B441] text-[#0E2A1C] font-semibold inline-flex items-center gap-2 disabled:opacity-50">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Truck className="w-4 h-4" />} Marcar enviado y avisar al cliente
        </button>
        <button type="button" onClick={onCancel} data-testid={`ship-cancel-${id}`} className="h-11 px-4 rounded-full border border-[#F6EEDC]/25 text-sm inline-flex items-center gap-1.5"><X className="w-4 h-4" /> Cancelar</button>
      </div>
    </form>
  );
};
